
export default {
  props: {
    staff: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      managerStats: null,
    };
  },
  computed: {
    position () {
      return this.staff.name;
    },
    fullName () {
      return `${this.staff.firstName} ${this.staff.lastName}`;
    },
    outputStats () {
      if (this.managerStats) {
        const record = this.managerStats?.record;
        return [
          { key: `Matches`, value: record.total },
          { key: `Wins`, value: record.won },
          { key: `Draws`, value: record.drew },
          { key: `Losses`, value: record.lost },
          { key: `Win %`, value: record.win_percentage },
        ];
      }
      return null;
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.position === `Manager` && this.staff.staffType.name === `First Team`) {
        this.getManagerStats();
      }
    });
  },
  methods: {
    async getManagerStats () {
      const team = this.getDefault(`team`);
      const request = await this.$getCustomStats(`manager/record/team/${team.id}`);
      if (request !== null) {
        this.managerStats = request;
      }
    },
  },
};
